/**
 * Physical jewelry label — GC420t roll measured by shop:
 *   total 88 mm wide × 10 mm tall
 *
 *   |← empty 44 →|← Plata/Bs 19 →|← gap 5 →|← barcode 20 →|
 *   0            44               63        68             88
 *
 * The empty neck and its fold mark are physical (adhesive + wrap), so nothing
 * prints before 44 mm. Within the printable tail the price panel comes first
 * and the barcode sits flush with the end of the strip.
 */
export const LABEL_PRINT_WIDTH_MM = 88;
export const LABEL_PRINT_HEIGHT_MM = 10;
/** Physical fold mark on the empty neck (guide only). */
export const LABEL_FOLD_MM = 22;
/** Gap between labels on the physical roll (mm). */
export const LABEL_PRINT_GAP_MM = 3;

/** Empty left tail: adhesive + fold, never printed on. */
export const LABEL_EMPTY_MM = 44;

/** Panel 1: material + price. */
export const LABEL_INFO_LEFT_MM = LABEL_EMPTY_MM; // 44
export const LABEL_INFO_WIDTH_MM = 19;

/** Every label text prints in bold Times New Roman (material also italic). */
export const LABEL_FONT_FAMILY = "'Times New Roman', Times, serif";

/** Panel 1, top to bottom: material, price + talla, código proveedor. */
export const LABEL_INFO_FONT_PT = 8;
/** Talla: one point under the price, so the price reads first. */
export const LABEL_TALLA_FONT_PT = 7;
/** Código proveedor: secondary to price and talla. */
export const LABEL_PROVIDER_FONT_PT = 6;
export const LABEL_INFO_PAD_X_MM = 0.8;
/** Air above the código proveedor line. */
export const LABEL_INFO_PROVIDER_GAP_MM = 0.4;

/** Fold between the panels, never printed on; doubles as the barcode quiet zone. */
export const LABEL_AFTER_INFO_GAP_MM = 5;

/** Panel 2: code + barcode, flush with the end of the strip. */
export const LABEL_BARCODE_LEFT_MM =
  LABEL_INFO_LEFT_MM + LABEL_INFO_WIDTH_MM + LABEL_AFTER_INFO_GAP_MM; // 68
export const LABEL_BARCODE_WIDTH_MM = LABEL_PRINT_WIDTH_MM - LABEL_BARCODE_LEFT_MM; // 20

/** GC420t: 203 dpi → 8 dots per mm. */
export const LABEL_DOTS_PER_MM = 8;

export function mmToDots(mm: number): number {
  return Math.round(mm * LABEL_DOTS_PER_MM);
}

/** One printer dot between characters, so the "/" in 101/14 does not touch the 1s. */
export const LABEL_TEXT_LETTER_SPACING_MM = 1 / LABEL_DOTS_PER_MM;
